import page from '../../../../constants/pages/page';
export const sortedKeyMap = { 'status.description': 'id_user_status', created_at_time: 'created_at' };
export const defaultSorted = [{ dataField: 'created_at', order: 'desc' }];
export const initialFilter = {
    filters: null,
    sortOrder: 'desc',
    sortField: 'created_at',
    pageNumber: page.pageNumber,
    pageSize: page.pageSize
};
